import { gql } from 'graphql-request'

export const ListSpeciGql = gql`
  query listSpecis($stationRecordNumber: String!, $speciType: SpeciType) {
    listSpecis(request: { stationRecordNumber: $stationRecordNumber, speciType: $speciType }) {
      results {
        id
        author
        created
        totalBales
        status
        sentToWoolStoreBy
        sentToWoolStoreAt
        originalSpeciId
        originalSpeciCreated
        originalSpeciSubmittedBy
        originalSpeciSubmittedAt
      }
    }
  }
`
